import { useEffect, useState } from 'react'
import { Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'
import { RankmiTable } from '@rankmi/rankmi-table'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBook } from '@fortawesome/pro-solid-svg-icons/faBook'
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle'
import { ISimpleRelatedCourse } from 'interfaces/learningPath'
import { TableSkeleton } from 'components/reusables/skeletons'
import { learningPathsService } from 'api/administration/learningPaths'
import { CourseLmsProfileType } from 'enum/course-lms-profile-type.enum'
import { Wrapper, Column, TooltipTitle } from './styled'

interface IProps {
  id: number
}

const Details = ({ id }: IProps) => {
  const { t } = useTranslation()
  const prefix =
    'administration.learningPaths.manage.create.content.prerequisites.details'
  const [courses, setCourses] = useState<ISimpleRelatedCourse[]>([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    getCourses()
  }, [id])

  const getCourses = async () => {
    setLoading(true)
    try {
      const response = await learningPathsService.getCoursesByLearningPath(id)
      setCourses(response)
    } catch {
      setCourses([])
    } finally {
      setLoading(false)
    }
  }

  const locale = {
    header: {
      rowsCount: t(`${prefix}.rowsCount`),
      rowsCount_plural: t(`${prefix}.rowsCountPlural`),
    },
  }

  const columns = [
    {
      title: t(`${prefix}.columns.name`),
      render: (data: ISimpleRelatedCourse) => data.course.name,
    },
    {
      title: (
        <Column>
          {t(`${prefix}.columns.required.title`)}
          <Tooltip
            title={
              <TooltipTitle>
                {t(`${prefix}.columns.required.description`)}
                <a
                  href="https://rankmi.odoo.com/knowledge/article#id=2622&cids=1"
                  target="_blank"
                  rel="noreferrer"
                >
                  {t(`${prefix}.columns.required.descriptionSuffix`)}
                </a>
              </TooltipTitle>
            }
            placement="top"
          >
            <FontAwesomeIcon icon={faInfoCircle} />
          </Tooltip>
        </Column>
      ),
      width: 139,
      render: (data: ISimpleRelatedCourse) =>
        data.required === CourseLmsProfileType.Required
          ? t(`${prefix}.columns.required.options.required`)
          : t(`${prefix}.columns.required.options.optional`),
    },
  ]

  return (
    <Wrapper>
      {loading ? (
        <TableSkeleton />
      ) : (
        <RankmiTable
          locale={locale}
          columnHeaders={columns}
          data={courses}
          total={courses.length}
          countIcon={faBook}
        />
      )}
    </Wrapper>
  )
}

export default Details
